import {
  CLEAR_USER_BY_ID,
  CLEAR_USERS,
  GET_USER_BY_ID,
  GET_USER_BY_ID_SUCCESS,
  SEARCH_USERS_SUCCESS,
  SET_USERS_LOADING,
  DEACTIVATE_USER,
  DEACTIVATE_USER_SUCCESS,
  DEACTIVATE_USER_ERROR,
  ACTIVATE_USER,
  ACTIVATE_USER_SUCCESS,
  ACTIVATE_USER_ERROR,
  DELETE_USER_BY_ID,
  DELETE_USER_BY_ID_SUCCESS,
  DELETE_USER_BY_ID_ERROR,
} from '../constants/ActionTypes';

const INIT_STATE = {
  loading: false,
  pageCount: 1,
  userById: {
    data: {},
    loading: false,
  },
  users: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CLEAR_USER_BY_ID:
      return {
        ...state,
        userById: {
          ...state.userById,
          data: {},
          loading: false,
        },
      };
    case CLEAR_USERS:
      return {
        ...state,
        pageCount: 1,
        users: [],
      };
    case GET_USER_BY_ID:
      return {
        ...state,
        userById: {
          ...state.userById,
          loading: !action.payload.forRefresh,
        },
      };
    case GET_USER_BY_ID_SUCCESS:
      return {
        ...state,
        userById: {
          ...state.userById,
          data: action.payload.user,
          loading: false,
        },
      };

    case DEACTIVATE_USER:
    case ACTIVATE_USER:
    case DELETE_USER_BY_ID:
      return {
        ...state,
        userById: {
          ...state.userById,
          loading: true,
        },
      };
    case DEACTIVATE_USER_SUCCESS:
    case ACTIVATE_USER_SUCCESS:
    case DELETE_USER_BY_ID_SUCCESS:
    case DEACTIVATE_USER_ERROR:
    case ACTIVATE_USER_ERROR:
    case DELETE_USER_BY_ID_ERROR:
      return {
        ...state,
        userById: {
          ...state.userById,
          loading: false,
        },
      };

    case SEARCH_USERS_SUCCESS:
      return {
        ...state,
        pageCount: action.payload.pageCount,
        users: action.payload.users,
      };
    case SET_USERS_LOADING:
      return {
        ...state,
        loading: action.payload.flag,
      };
    default:
      return state;
  }
};
